export default "__VITE_ASSET__a666c512__"